import { render } from "./CategoryBreadcrumbComponent.vue?vue&type=template&id=599c2de5"
import script from "./CategoryBreadcrumbComponent.vue?vue&type=script&lang=js"
export * from "./CategoryBreadcrumbComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/CategoryBreadcrumbComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "599c2de5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('599c2de5', __exports__)) {
    api.reload('599c2de5', __exports__)
  }
  
  module.hot.accept("./CategoryBreadcrumbComponent.vue?vue&type=template&id=599c2de5", () => {
    api.rerender('599c2de5', render)
  })

}


export default __exports__